import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  mode:'history',
  routes: [
    {
      path: '/',
      name: 'dashboard',
      component: ()=>import('@/views/home/index'),
      redirect:'/home',
      children:[
        {
          path:'home',
          name:'home',
          component: () => import('@/views/home/home')
        },
        {
          path:'source',
          name:'source',
          component: () => import('@/views/home/source')
        },
        {
          path:'order',
          name:'orderList',
          component: () => import('@/views/home/order')
        },
        {
          path:'agreement',
          name:'agreement',
          component: () => import('@/views/home/agreement')
        },
      ]
    },
    {
      path: '/remarkLogin',
      name: 'remarkLogin',
      component: ()=>import('@/views/account/remarkLogin')
    },
    {
      path: '/choose',
      component: () => import('@/views/dashboard/choose'),
      name: 'DashboardChoose',
      hidden: true
    },
    // {
    //   path: "/testPage",
    //   component: () => import("@/views/testPage/index"),
    //   hidden: true,
    // },
    {
      path: "/qrScanPage",
      component: () => import("@/views/testPage/qrScan"),
      hidden: true,
    },
    {
      path: '/activity/app/driver',
      name: 'download',
      component: ()=>import('@/views/download/newIndex.vue')
    },
    {
      path: '/activity/app/fleet',
      name: 'downloadCompanyIndex1',
      component: ()=>import('@/views/download/companyIndex.vue')
    },
    {
      path:'/voucher',
      name:'voucher',
      component:() => import('@/views/site/voucher/index.vue')
    },
    {
      path:'/download',
      name:'download',
      component:() => import('@/views/download/newIndex')
    },
    {
      path: '/ddorder',
      name:"ddorder",
      component: () => import('@/views/ddorder'),
      hidden: true
    },
    {
      path: '/ddorderlist',
      name:"ddorderlist",
      component: () => import('@/views/ddorderlist'),
      hidden: true
    },
    {
      path: '/ddInvoice',
      component: () => import('@/views/ddInvoice'),
      hidden: true
    },
    {
      path: '/pdfviewer',
      component: () => import('@/views/pdfviewer'),
      hidden: true
    },
    {
      path: '/sourceviewer',
      component: () => import('@/views/sourceViewer'),
      hidden: true
    },
    {
      path: '/tender',
      component: () => import('@/views/outline/tender'),
      hidden: true
    },
    {
      path: '/account',
      name: 'account',
      component: ()=>import('@/views/account/index'),
      children:[
        {
          path: 'login',
          name: 'login',
          component: ()=>import('@/views/account/login')
        },
        {
          path: 'register',
          name: 'register',
          component: ()=>import('@/views/account/register')
        }, 
        {
          path: 'forget',
          name: 'forget',
          component: ()=>import('@/views/account/forget')
        }, 
        {
          path: 'wxinfo',
          name: 'wxinfo',
          component: ()=>import('@/views/account/wxinfo')
        },
        {
          path: 'wxcode',
          name: 'wxcode',
          component: ()=>import('@/views/account/wxcode')
        },
        {
          path: 'codeLogin',
          name: 'codeLogin',
          component: ()=>import('@/views/account/codeLogin')
        },
      ]
    },
    {
      path: '/oldAccount',
      name: 'account',
      component: ()=>import('@/views/oldAccount/index'),
      children:[
        {
          path: 'login',
          name: 'oldlogin',
          component: ()=>import('@/views/oldAccount/login')
        },
        {
          path: 'reg',
          name: 'oldregister',
          component: ()=>import('@/views/oldAccount/reg')
        }, 
        {
          path: 'forget',
          name: 'oldforget',
          component: ()=>import('@/views/oldAccount/forget')
        }, 
      ]
    },  
    {
      path: '/site',
      name: 'site',
      component: ()=>import('@/views/site'),
      children:[
        {
          path: 'search/source',
          name: 'source',
          component: ()=>import('@/views/site/search/source')
        }, 
        {
          path: 'search/order',
          name: 'order',
          component: ()=>import('@/views/site/search/order')
        }, 
        {
          path: 'search/transport',
          name: 'transport',
          component: ()=>import('@/views/site/search/transport')
        }, 
        {
          path: 'search/location',
          name: 'location',
          component: ()=>import('@/views/site/search/location')
        }, 
        {
          path: 'app/content-detail',
          name: 'detail',
          component: ()=>import('@/views/site/content/detail')
        }, 
        {
          path: 'app/score-detail',
          name: 'score-detail',
          component: ()=>import('@/views/site/content/detail/score-detail')
        }, 
        {
          path: 'app/mobile-content',
          name: 'mobile-content',
          component: ()=>import('@/views/site/content/mobile/index')
        }, 
      ]
    },
    {
      path: '/admin',
      name: 'admin',
      component: ()=>import('@/views/admin'),
      children:[
        {
          path: 'dashboard/home',
          name: 'home',
          component: ()=>import('@/views/admin/dashboard/homes'),
          meta:{
            isLock:true
          }
        }, 
        {
          path: 'dashboard/account',
          name: 'account',
          component: ()=>import('@/views/admin/dashboard/account'),
          meta:{
            isLock:true
          }
        }, 
        {
          path: 'auth/company',
          name: 'company',
          component: ()=>import('@/views/admin/auth/company'),
          meta:{
            isLock:true
          }
        }, 
        {
          path: 'auth/shipper',
          name: 'shipper',
          component: ()=>import('@/views/admin/auth/shipper'),
          meta:{
            isLock:true
          }
        }, 
        {
          path: 'auth/agent',
          name: 'shipper',
          component: ()=>import('@/views/admin/auth/agent'),
          meta:{
            isLock:true
          }
        }, 
      ],
    
    },
    // {
    //   path: '/admin/auth',
    //   redirect: '/admin/auth/company',
    // },
    {
      path: '/:id/v1',
      name: 'theme',
      component: ()=>import('@/views/theme/v1'),
    
    },
    {
      path: '/:id/v1/news',
      name: 'news',
      component: ()=>import('@/views/theme/v1/news/index')
    },
    {
      path: '/:id/v1/new_id',
      name: 'new_id',
      component: ()=>import('@/views/theme/v1/new_id/index')
    },
    {
      path: '/:id/v1/product',
      name: 'product',
      component: ()=>import('@/views/theme/v1/product/index')
    },
     {
      path: '/:id/v1/product_id',
      name: 'product_id',
      component: ()=>import('@/views/theme/v1/product_id/index')
    },
    {
      path: '/:id/v1/login',
      name: 'login',
      component: ()=>import('@/views/theme/v1/login/index')
    },
    {
      path: '/:id/v1/reg',
      name: 'reg',
      component: ()=>import('@/views/theme/v1/reg/index')
    },
    {
      path: '/:id/v1/forget',
      name: 'forget',
      component: ()=>import('@/views/theme/v1/forget/index')
    },
    {
      path: '/:id/v2',
      name: 'theme',
      component: ()=>import('@/views/theme/v2'),
    },
    {
      path: '/:id/v2/news',
      name: 'news',
      component: ()=>import('@/views/theme/v2/news/index')
    },
    {
      path: '/:id/v2/new_id',
      name: 'new_id',
      component: ()=>import('@/views/theme/v2/new_id/index')
    },
    {
      path: '/:id/v2/product',
      name: 'product',
      component: ()=>import('@/views/theme/v2/product/index')
    },
     {
      path: '/:id/v2/product_id',
      name: 'product_id',
      component: ()=>import('@/views/theme/v2/product_id/index')
    },
    {
      path: '/:id/v2/login',
      name: 'login',
      component: ()=>import('@/views/theme/v2/login/index')
    },
    {
      path: '/:id/v2/reg',
      name: 'reg',
      component: ()=>import('@/views/theme/v2/reg/index')
    },
    {
      path: '/:id/v2/forget',
      name: 'forget',
      component: ()=>import('@/views/theme/v2/forget/index')
    },
    {
      path: '/download/:id',
      name: 'download',
      component: ()=>import('@/views/download/newIndex.vue')
    },
    {
      path: '/download/company/:id',
      name: 'downloadCompanyIndex',
      component: ()=>import('@/views/download/companyIndex.vue')
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js